@if (url) {
  @if (value) {
    <a class="text-theme-primary underline" [routerLink]="url" (mousedown)="$event.stopPropagation()">
      {{ value }}
    </a>
  } @else {
    <span class="text-slate-300">-</span>
  }
}
@else {
  <span class="text-red-500 font-semibold">No link specified</span>
}
